{
  "onboarding": {
    "tally": {
      "line": "{{total}}: {{states}}",
      "separator": ", ",
      "outstanding": "Outstanding",
      "otherState": "{{count}} other",
      "missing": {
        "purchasing_units": {
          "none": "No active Purchasing Unit: none added yet.",
          "some": "No active Purchasing Unit: {{states}}."
        }
      },
      "subject": {
        "regions_zero": "No regions",
        "regions_one": "{{count}} region",
        "regions_two": "{{count}} regions",
        "regions_few": "{{count}} regions",
        "regions_many": "{{count}} regions",
        "regions_other": "{{count}} regions",
        "purchasing_units_zero": "No purchasing units",
        "purchasing_units_one": "{{count}} purchasing unit",
        "purchasing_units_two": "{{count}} purchasing units",
        "purchasing_units_few": "{{count}} purchasing units",
        "purchasing_units_many": "{{count}} purchasing units",
        "purchasing_units_other": "{{count}} purchasing units",
        "categories_zero": "No categories",
        "categories_one": "{{count}} category",
        "categories_two": "{{count}} categories",
        "categories_few": "{{count}} categories",
        "categories_many": "{{count}} categories",
        "categories_other": "{{count}} categories",
        "users_zero": "No users",
        "users_one": "{{count}} user",
        "users_two": "{{count}} users",
        "users_few": "{{count}} users",
        "users_many": "{{count}} users",
        "users_other": "{{count}} users",
        "approval_rules_zero": "No approval rules",
        "approval_rules_one": "{{count}} approval rule",
        "approval_rules_two": "{{count}} approval rules",
        "approval_rules_few": "{{count}} approval rules",
        "approval_rules_many": "{{count}} approval rules",
        "approval_rules_other": "{{count}} approval rules",
        "budgets_zero": "No budgets",
        "budgets_one": "{{count}} budget",
        "budgets_two": "{{count}} budgets",
        "budgets_few": "{{count}} budgets",
        "budgets_many": "{{count}} budgets",
        "budgets_other": "{{count}} budgets",
        "suppliers_zero": "No suppliers",
        "suppliers_one": "{{count}} supplier",
        "suppliers_two": "{{count}} suppliers",
        "suppliers_few": "{{count}} suppliers",
        "suppliers_many": "{{count}} suppliers",
        "suppliers_other": "{{count}} suppliers",
        "framework_agreements_zero": "No framework agreements",
        "framework_agreements_one": "{{count}} framework agreement",
        "framework_agreements_two": "{{count}} framework agreements",
        "framework_agreements_few": "{{count}} framework agreements",
        "framework_agreements_many": "{{count}} framework agreements",
        "framework_agreements_other": "{{count}} framework agreements",
        "catalogue_items_zero": "No catalogue items",
        "catalogue_items_one": "{{count}} catalogue item",
        "catalogue_items_two": "{{count}} catalogue items",
        "catalogue_items_few": "{{count}} catalogue items",
        "catalogue_items_many": "{{count}} catalogue items",
        "catalogue_items_other": "{{count}} catalogue items",
        "active_operational_records_zero": "No active purchasing units",
        "active_operational_records_one": "{{count}} active purchasing unit",
        "active_operational_records_two": "{{count}} active purchasing units",
        "active_operational_records_few": "{{count}} active purchasing units",
        "active_operational_records_many": "{{count}} active purchasing units",
        "active_operational_records_other": "{{count}} active purchasing units"
      },
      "state": {
        "regions": {
          "active": "{{count}} active",
          "inactive": "{{count}} inactive",
          "archived": "{{count}} archived"
        },
        "purchasing_units": {
          "active": "{{count}} active",
          "archived": "{{count}} archived",
          "draft": "{{count}} draft",
          "inactive": "{{count}} inactive"
        },
        "categories": {
          "active": "{{count}} active",
          "inactive": "{{count}} inactive",
          "archived": "{{count}} archived"
        },
        "users": {
          "active": "{{count}} active",
          "invited": "{{count}} invited",
          "inactive": "{{count}} inactive",
          "suspended": "{{count}} suspended"
        },
        "approval_rules": {
          "in_force": "{{count}} in force",
          "scheduled": "{{count}} scheduled",
          "expired": "{{count}} expired",
          "inactive": "{{count}} inactive"
        },
        "budgets": {
          "active": "{{count}} active",
          "draft": "{{count}} draft",
          "frozen": "{{count}} frozen",
          "closed": "{{count}} closed"
        },
        "suppliers": {
          "active_qualified": "{{count}} active and qualified",
          "active_not_qualified": "{{count}} active without a qualification in force",
          "draft": "{{count}} draft",
          "suspended": "{{count}} suspended",
          "archived": "{{count}} archived"
        },
        "framework_agreements": {
          "in_force": "{{count}} in force",
          "not_started": "{{count}} not started yet",
          "expired": "{{count}} expired",
          "draft": "{{count}} draft",
          "suspended": "{{count}} suspended",
          "terminated": "{{count}} terminated"
        },
        "catalogue_items": {
          "active_with_source": "{{count}} active with an active source",
          "active_without_source": "{{count}} active without an active source",
          "inactive": "{{count}} inactive",
          "archived": "{{count}} archived"
        },
        "active_operational_records": {
          "covered": "{{count}} covered",
          "at_risk": "{{count}} at risk",
          "blocked": "{{count}} blocked",
          "idle": "{{count}} where nobody can raise a purchase yet"
        }
      }
    }
  }
}
